import { App } from 'vue';
import vAlignDirective from './src/align.ts';
export { vAlignDirective as vAlign };
declare const _default: {
    install: (app: App) => void;
};
export default _default;
